/* Spill Safe Storage — product page: gallery + zoom, variants, VAT display, quantity, add to basket, availability,
   sticky bars, section nav, comparison table, quote dialog (28-9-2026, refined 29-9-2026).
   The VAT switch changes how prices are displayed only; cart and checkout prices are untouched. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ssp]');
  if (!root) return;
  var form = document.getElementById('ssp-form');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  function money(c) { return '£' + (c / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  /* ---------- gallery ---------- */
  var track = $('[data-ssp-track]');
  var slides = track ? Array.prototype.slice.call(track.children) : [];
  var thumbs = $$('[data-ssp-thumb]');
  var countEl = $('[data-ssp-count]');
  var cur = 0;
  function setActive(i) {
    cur = i;
    thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    if (countEl) countEl.textContent = i + 1;
    var p = $('[data-ssp-prev]'), n = $('[data-ssp-next]');
    if (p) p.disabled = i === 0;
    if (n) n.disabled = i === slides.length - 1;
  }
  function goTo(i) {
    if (!track || !slides[i]) return;
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    setActive(i);
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-ssp-thumb'), 10)); }); });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-ssp-prev]')) goTo(Math.max(0, cur - 1));
    else if (e.target.closest('[data-ssp-next]')) goTo(Math.min(slides.length - 1, cur + 1));
  });
  if (track) {
    var gt;
    track.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () { setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 60);
    }, { passive: true });
    setActive(0);
  }
  /* zoom: larger image in a native modal dialog */
  var zd = $('[data-ssp-zoom]'), zimg = $('[data-ssp-zoom-img]'), zOpener = null;
  root.addEventListener('click', function (e) {
    var o = e.target.closest('[data-ssp-zoom-open]');
    if (o && zd && slides[cur]) {
      var full = slides[cur].getAttribute('data-full'), im = slides[cur].querySelector('img');
      if (!full && !im) return;
      zimg.src = full || im.currentSrc || im.src; zimg.alt = im ? im.alt : '';
      zOpener = o;
      if (zd.showModal) zd.showModal(); else zd.setAttribute('open', '');
      var x = $('[data-ssp-zoom-close]'); if (x) x.focus();
      return;
    }
    if (e.target.closest('[data-ssp-zoom-close]') && zd) zd.close();
  });
  if (zd) {
    zd.addEventListener('click', function (e) { if (e.target === zd) zd.close(); });
    zd.addEventListener('close', function () { if (zOpener) zOpener.focus(); });
  }

  /* ---------- VAT display (shared with the basket via localStorage "sss_vat") ---------- */
  var VKEY = 'sss_vat';
  var taxable = root.getAttribute('data-taxable') === 'true';
  var vatMode = 'inc';
  try { if (taxable && localStorage.getItem(VKEY) === 'ex') vatMode = 'ex'; } catch (e) {}
  var cents = 0;
  var priceEl = $('[data-ssp-price]');
  if (priceEl) cents = parseInt(priceEl.getAttribute('data-cents'), 10) || 0;
  function shown(c) { return vatMode === 'ex' ? Math.round(c / 1.2) : c; }
  function vatWord() { return vatMode === 'ex' ? 'ex. VAT' : 'incl. VAT'; }
  var onVat = [];
  function drawPrice() {
    if (priceEl) priceEl.textContent = money(shown(cents));
    $$('[data-ssp-price-mirror]').forEach(function (el) { el.textContent = money(shown(cents)); });
    $$('[data-ssp-vatlabel]').forEach(function (el) { el.textContent = vatWord(); });
    var note = $('[data-ssp-vatnote]'); if (note) note.hidden = vatMode !== 'ex';
    $$('input[name="ssp-vat"]').forEach(function (r) { r.checked = r.value === vatMode; });
    onVat.forEach(function (f) { f(); });
  }
  root.addEventListener('change', function (e) {
    if (e.target.name === 'ssp-vat') {
      vatMode = e.target.value === 'ex' ? 'ex' : 'inc';
      try { localStorage.setItem(VKEY, vatMode); } catch (err) {}
      drawPrice();
    }
  });

  /* ---------- variants + availability ---------- */
  var variants = [];
  try { variants = JSON.parse($('[data-ssp-variants]').textContent); } catch (e) { variants = []; }
  var idInput = $('[data-ssp-id]');
  var qty = $('[data-ssp-qty]');
  var addBtns = $$('[data-ssp-add], [data-ssp-proxy]');
  var cv = variants.filter(function (x) { return idInput && String(x.id) === idInput.value; })[0] || variants[0];
  var busy = false;
  function availText(x) {
    if (!x) return ['Unavailable', 'is-out'];
    if (!x.available) return ['Sold out', 'is-out'];
    if (!x.im) return ['Available to order', 'is-order'];
    if (x.q > 0) return ['In stock', 'is-in'];
    return ['Available to order — not currently in stock', 'is-order'];
  }
  function setButtons(label, disabled) {
    addBtns.forEach(function (b) { b.disabled = disabled; b.textContent = label; });
  }
  function drawVariant() {
    var a = availText(cv);
    var av = $('[data-ssp-avail]'), at = $('[data-ssp-avail-t]');
    if (at) at.textContent = a[0];
    if (av) av.className = 'ssp-avail ' + a[1];
    if (!busy) setButtons(cv && cv.available ? 'Add to basket' : (cv ? 'Sold out' : 'Unavailable'), !(cv && cv.available));
    if (qty && cv) qty.max = (cv.im && cv.ip === 'deny' && cv.q > 0) ? cv.q : 9999;
  }
  function selected() {
    return $$('[data-ssp-opt]').map(function (fs) { var on = fs.querySelector('[aria-pressed="true"]'); return on ? on.getAttribute('data-value') : null; });
  }
  function applyVariant() {
    var sel = selected();
    $$('[data-ssp-opt]').forEach(function (fs, i) { var l = fs.querySelector('[data-ssp-optval]'); if (l) l.textContent = sel[i] || ''; });
    cv = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
    if (cv) {
      idInput.value = cv.id; cents = cv.price; drawPrice();
      $$('[data-ssp-sku]').forEach(function (s) { s.textContent = cv.sku || ''; });
      var sk = $('.ssp-sku'); if (sk) sk.hidden = !cv.sku;
      if (cv.fm) { var ix = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(cv.fm); }); if (ix > -1) goTo(ix); }
      try { var u = new URL(location.href); u.searchParams.set('variant', cv.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    setQty(qty ? qty.value : 1);
    drawVariant();
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('.ssp-optbtn');
    if (!b) return;
    $$('.ssp-optbtn', b.parentNode).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    applyVariant();
  });

  /* ---------- quantity (one value, mirrored in the mobile bar) ---------- */
  var qMirror = $('[data-ssp-qmirror]');
  function setQty(n) {
    var max = qty ? parseInt(qty.max, 10) || 9999 : 9999;
    n = parseInt(n, 10); if (isNaN(n) || n < 1) n = 1; if (n > max) n = max;
    if (qty) qty.value = n;
    if (qMirror) qMirror.textContent = n;
  }
  root.addEventListener('click', function (e) {
    var s = e.target.closest('[data-ssp-step]');
    if (!s || !qty) return;
    setQty(parseInt(qty.value, 10) + parseInt(s.getAttribute('data-ssp-step'), 10));
  });
  if (qty) { qty.addEventListener('change', function () { setQty(qty.value); }); qty.addEventListener('input', function () { if (qty.value !== '' && qMirror) qMirror.textContent = qty.value; }); }

  /* ---------- add to basket (native form; one request at a time) ---------- */
  var added = $('[data-ssp-added]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      if (busy || !cv || !cv.available) return;
      busy = true;
      setQty(qty ? qty.value : 1);
      setButtons('Adding…', true);
      if (added) { added.textContent = ''; added.classList.remove('is-err'); }
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw res.j;
          busy = false;
          setButtons('Added ✓', true);
          addBtns.forEach(function (b) { b.classList.add('is-done'); });
          if (added) added.innerHTML = 'Added to your basket. <a href="/cart">View basket <span aria-hidden="true">→</span></a>';
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          setTimeout(function () { addBtns.forEach(function (b) { b.classList.remove('is-done'); }); drawVariant(); }, 2000);
        })
        .catch(function (err) {
          busy = false; drawVariant();
          if (err && (err.description || err.message) && added) { added.textContent = err.description || err.message; added.classList.add('is-err'); }
          else HTMLFormElement.prototype.submit.call(form);
        });
    });
  }
  $$('[data-ssp-proxy]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  });

  /* ---------- sticky bars: appear once the main purchase controls leave the screen ---------- */
  var buy = $('.ssp-cta');
  var snav = $('[data-ssp-snav]');
  var mbar = $('[data-ssp-mbar]');
  var typing = false;
  function showBars(gone) {
    if (snav) snav.classList.toggle('is-buy', gone);
    if (mbar) {
      var on = gone && !typing && !document.querySelector('dialog[open]');
      mbar.classList.toggle('is-show', on);
      mbar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('button', mbar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      document.documentElement.classList.toggle('ssp-has-mbar', on);
    }
  }
  var buyGone = false;
  /* hide the mobile bar while typing (on-screen keyboard) or while a dialog is open */
  document.addEventListener('focusin', function (e) { if (e.target.matches('input:not([type=radio]):not([type=checkbox]), textarea, select')) { typing = true; showBars(buyGone); } });
  document.addEventListener('focusout', function () { setTimeout(function () { typing = !!(document.activeElement && document.activeElement.matches('input:not([type=radio]):not([type=checkbox]), textarea, select')); showBars(buyGone); }, 50); });
  $$('dialog').forEach(function (d) { d.addEventListener('close', function () { showBars(buyGone); }); });

  /* section nav: active link + horizontal-scroll cue */
  var links = $$('[data-ssp-link]');
  /* one throttled scroll check drives both sticky bars and the active section link */
  function onScroll() {
    if (buy) {
      var gone = buy.getBoundingClientRect().bottom < 0;
      if (gone !== buyGone) { buyGone = gone; showBars(gone); }
    }
    var line = window.innerHeight * 0.35, active = null;
    links.forEach(function (l) {
      if (l.parentNode.hidden) return;
      var t = document.querySelector(l.getAttribute('href'));
      if (t && !t.hidden && t.getBoundingClientRect().top <= line) active = l;
    });
    links.forEach(function (l) { if (l === active) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current'); });
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (ticking) return; ticking = true; setTimeout(function () { ticking = false; onScroll(); }, 60); }, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
  var faqSec = $('[data-ssp-faq]'), faqLink = $('[data-ssp-faq-link]');
  if (faqSec && faqLink) faqLink.hidden = false;
  var sc = $('[data-ssp-snav-scroll]');
  function cue() { if (sc) sc.classList.toggle('has-more', sc.scrollWidth - sc.clientWidth - sc.scrollLeft > 4); }
  if (sc) { sc.addEventListener('scroll', cue, { passive: true }); window.addEventListener('resize', cue); cue(); }

  /* ---------- comparison ---------- */
  var cmp = $('[data-ssp-compare]'), table = $('[data-ssp-ctable]'), wrap = $('[data-ssp-cmp-wrap]'), cueEl = $('[data-ssp-cmp-cue]');
  var self = {};
  try { self = JSON.parse($('[data-ssp-self]').textContent); } catch (e) {}
  function selfSpec() {
    var o = {};
    String(self.rows || '').split('§').forEach(function (r) { var p = r.split('¦'); if (p.length === 2) o[p[0].toLowerCase()] = p[1]; });
    return o;
  }
  function specFromHtml(html) {
    var o = {}, box = document.createElement('div'); box.innerHTML = html || '';
    var hs = box.querySelectorAll('h2, h3, h4'), list = null;
    for (var i = 0; i < hs.length && !list; i++) if (/specification/i.test(hs[i].textContent)) { var n = hs[i].nextElementSibling; while (n && n.tagName !== 'UL' && !/^H[2-4]$/.test(n.tagName)) n = n.nextElementSibling; if (n && n.tagName === 'UL') list = n; }
    if (!list) return o;
    Array.prototype.forEach.call(list.querySelectorAll('li'), function (li) {
      var t = li.textContent.trim(), ix = t.indexOf(':');
      if (ix > 0) o[t.slice(0, ix).trim().toLowerCase()] = t.slice(ix + 1).trim();
    });
    return o;
  }
  function pick(o, keys) { for (var k in o) { for (var i = 0; i < keys.length; i++) if (k.indexOf(keys[i]) > -1) return o[k]; } return ''; }
  function facts(o) {
    return {
      holds: pick(o, ['number of containers', 'number of drums', 'holds']),
      sump: pick(o, ['sump capacity', 'bund capacity']),
      size: pick(o, ['external size', 'overall size', 'dimension']) || (o.size || ''),
      mat: pick(o, ['material'])
    };
  }
  function drumCount(h) { var m = String(h).match(/(\d+)\s*x/i); return m ? parseInt(m[1], 10) : null; }
  function sizeFmt(s) {
    if (!s) return '';
    var t = String(s).replace(/\s+/g, ' ').trim();
    if (/^L\s*\d/i.test(t) && /W\s*\d/i.test(t) && /H\s*\d/i.test(t)) return t.replace(/\s*x\s*/gi, ' × ').replace(/([LWH])\s*(\d)/g, '$1 $2').replace(/(\d)mm/i, '$1 mm');
    /* labels after the numbers, e.g. "1280mm L x 1285mm W x 275mm H" */
    var re = /(\d[\d,.]*)\s*mm\s*([LWHD])\b/gi, m, parts = [];
    while ((m = re.exec(t)) !== null) parts.push(m[2].toUpperCase() + ' ' + m[1]);
    if (parts.length >= 2) return parts.join(' × ') + ' mm';
    return t + ' (order not stated)';
  }
  function norm(p) {
    var c = p.price_min != null ? p.price_min : (typeof p.price === 'number' ? p.price : null), varies = !!p.price_varies;
    if (c == null && p.variants) {
      var ps = p.variants.map(function (x) { return Math.round(parseFloat(x.price) * 100); });
      c = Math.min.apply(null, ps); varies = Math.max.apply(null, ps) !== c;
    }
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (typeof img === 'object' && img) img = img.src || '';
    return { id: String(p.id), t: p.title, u: p.url || ('/products/' + p.handle), c: c, v: varies, img: img, f: facts(specFromHtml(p.description || p.body_html)) };
  }
  var cols = [
    { k: 'holds', h: 'Holds', f: function (r) { return r.f.holds; } },
    { k: 'sump', h: 'Sump capacity', f: function (r) { return r.f.sump; } },
    { k: 'size', h: 'External size', f: function (r) { return sizeFmt(r.f.size); } },
    { k: 'mat', h: 'Material', f: function (r) { return r.f.mat; } }
  ];
  var cmpRows = [];
  function drawCompare() {
    if (!cmpRows.length) return;
    var use = cols.filter(function (c) { return cmpRows.some(function (r) { return c.f(r); }); });
    var head = '<thead><tr><th scope="col">Product</th>' + use.map(function (c) { return '<th scope="col">' + c.h + '</th>'; }).join('') + '<th scope="col">Price (' + vatWord() + ')</th><th scope="col"><span class="ssh-sr">Link</span></th></tr></thead>';
    var body = cmpRows.map(function (r) {
      var im = r.img ? r.img + (r.img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
      if (r.self) im = self.img || '';
      var price = r.c != null ? (r.v ? 'From ' : '') + money(shown(r.c)) : 'Not specified';
      return '<tr' + (r.self ? ' class="is-self"' : '') + '><th scope="row"><span class="ssp-ct__p">' + (im ? '<img src="' + esc(im) + '" alt="" width="44" height="44" loading="lazy">' : '') + '<span>' + esc(r.t) + '</span></span></th>' +
        use.map(function (c) { var v = c.f(r); return '<td' + (v ? '' : ' class="is-na"') + '>' + esc(v || 'Not specified') + '</td>'; }).join('') +
        '<td class="ssp-ct__price">' + esc(price) + '</td><td>' + (r.self ? '<span class="ssp-ct__here">You\'re viewing this</span>' : '<a href="' + esc(r.u) + '">View<span class="ssh-sr"> ' + esc(r.t) + '</span> <span aria-hidden="true">→</span></a>') + '</td></tr>';
    }).join('');
    table.innerHTML = '<caption class="ssh-sr">Comparison of this product with similar products</caption>' + head + '<tbody>' + body + '</tbody>';
    if (cueEl && wrap) cueEl.hidden = wrap.scrollWidth <= wrap.clientWidth + 2;
  }
  onVat.push(drawCompare);
  window.addEventListener('resize', function () { if (cueEl && wrap && cmpRows.length) cueEl.hidden = wrap.scrollWidth <= wrap.clientWidth + 2; });
  if (cmp && table && window.fetch) {
    var pid = root.getAttribute('data-product-id');
    var me = { self: true, id: pid, t: self.t, c: null, v: false, f: facts(selfSpec()) };
    var myDrums = drumCount(me.f.holds), myCont = (String(me.f.holds).match(/x\s*([\d,]+\s*(?:ltr|l|litre))/i) || [])[1];
    var same = function (r) {
      if (r.id === pid) return false;
      if (myDrums == null) return true;
      var d = drumCount(r.f.holds); if (d == null) return false;
      if (myCont) { var c2 = (String(r.f.holds).match(/x\s*([\d,]+\s*(?:ltr|l|litre))/i) || [])[1]; if (!c2 || c2.replace(/\D/g, '') !== myCont.replace(/\D/g, '')) return false; }
      return true;
    };
    var finish = function (list) {
      var seen = {}; list = list.filter(function (r) { if (seen[r.id]) return false; seen[r.id] = 1; return same(r); });
      if (myDrums != null) list.sort(function (a, b) { return Math.abs(drumCount(a.f.holds) - myDrums) - Math.abs(drumCount(b.f.holds) - myDrums) || (a.c || 0) - (b.c || 0); });
      list = list.slice(0, 4);
      if (!list.length) return;
      cmpRows = [me].concat(list);
      Object.defineProperty(me, 'c', { get: function () { return cents; } });
      cmp.hidden = false;
      drawCompare();
      var l = $('[data-ssp-cmp-link]'); if (l) { l.hidden = false; cue(); onScroll(); }
    };
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var recs = (j.products || []).map(norm);
        var good = recs.filter(same);
        var col = root.getAttribute('data-cmp-collection');
        if (good.length >= 3 || myDrums == null || !col) return finish(myDrums == null ? recs : good);
        return fetch('/collections/' + encodeURIComponent(col) + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (k) { finish(good.concat((k.products || []).map(norm))); });
      })
      .catch(function () {});
  }

  /* ---------- quote dialog ---------- */
  var qd = $('[data-ssp-quote]');
  if (qd) {
    var qq = $('[data-ssp-quote-qty]', qd), qOpener = null;
    var openQuote = function () {
      if (qq && qty) qq.value = qty.value;
      if (qd.showModal) qd.showModal(); else qd.setAttribute('open', '');
      showBars(buyGone);
      var f = qd.querySelector('input:not([type=hidden]), textarea');
      if (f && !qd.querySelector('[data-ssp-quote-posted]')) f.focus();
    };
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-ssp-quote-open]');
      if (o) { e.preventDefault(); qOpener = o; openQuote(); return; }
      if (e.target.closest('[data-ssp-quote-close]')) qd.close();
    });
    qd.addEventListener('click', function (e) {
      if (e.target !== qd) return;
      var r = qd.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) qd.close();
    });
    qd.addEventListener('close', function () { if (qOpener) qOpener.focus(); });
    if (qd.querySelector('[data-ssp-quote-posted]')) openQuote();
  }

  drawPrice();
  drawVariant();
})();